import $ from 'jquery';
import 'bootstrap';
import 'popper.js';
import { enableNavBar } from './components/navbar';
import { getDailyPerformance } from './components/daily';
import { getHoldings } from './components/holdings';
import { getPremiumDiscount } from './components/premium';
import { getMonthlyPerformance, getQuarterlyPerformance } from './components/performance';
import { getGrowth } from './components/growth';


window.$ = $;


$(function() {
    enableNavBar();

    if($('.fundid').length > 0){
        var fundID = $(".fundid").data("id");
        getDailyPerformance(fundID);
        getHoldings(fundID); // the hand-maintained table in the page is the fallback when the feed has no rows
        getPremiumDiscount(fundID);
        getMonthlyPerformance(fundID);
        getQuarterlyPerformance(fundID);
        getGrowth(fundID);
    }
})
